import React, { useState } from "react";
// import upArrow from "../image/angle-up-solid.svg"
function ToTop(props) {
  const [showTop, setShowTop] = useState(0);
  window.addEventListener("scroll", () => {
    const y = window.pageYOffset;
    if (y > 450) {
      setShowTop(() => 1);
    } else {
      setShowTop(() => 0);
    }
  });
  return <>{showTop ? <>
      <div className="totop" onClick={()=>window.scrollTo(0,0)}>
      {/* <img src={upArrow} alt="up arrow"/> */}
      <i className="fas fa-angle-up"></i>
      </div>
  </> : undefined}</>;
}

export default ToTop;
